export default __webpack_public_path__ + "static/googleWalletGraphic-3134698c7c1502547041fc4a7d031ab7.svg";